import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import type { Cell as RTCell } from 'react-table';
import type { GetRecentFiles } from '@trinity/chat/api/interfaces/users';
import type { RecentFilesItem } from '@/types/workspace.table';
import { getLocationFor } from '@trinity/chat-components';
import { FileIcon } from '@trinity/chat-components/components/icons/File/index.js';
import { useTheme } from '@trinity/chat-components/components/Theme/index.js';
import styles from './style/Cells.module.css';


interface NameCellProps extends RTCell<GetRecentFiles.Response['items'][number]> { }

function NameCell({ row: { original: data } }: NameCellProps) {
  const theme = useTheme();

  const to = getLocationFor.workspaces.file({
    fileId: data.object.entityId,
  });

  return (
    <div className={styles.name}>
      <FileIcon className={styles.fileIcon} extension={data.file.extension} />
      <Link
        className={styles.link}
        to={to}
        style={{ '--link-hover-color': theme.palette.primary.main } as React.CSSProperties}
      >
        {data.object.name}
      </Link>
    </div>
  );
}

function CreatedOnCell({ row: { original: data } }: RTCell<RecentFilesItem>) {
  return format(data.object.createdOn, 'MM/dd/yyyy');
}

export const Cell = {
  CreatedOn: CreatedOnCell,
  Name: NameCell,
};